module.exports = __webpack_public_path__ + "static/media/ico_filter.c32737e0.svg";